<template>
  <unicom-layout-cartao semFiltro>
    <unicom-linha class="linha-embaixo">
      <unicom-coluna sm="12" style="padding-bottom: 24px">
        <div class="titulo negrito cor-fonte fonte-primaria">
          Tipo de Parceiro Comercial
        </div>
      </unicom-coluna>
    </unicom-linha>

    <posto-coleta-exames-componente
      v-if="objetoServicos['Posto de Coleta de Exames'].ativo"
      :dadosServidor="this.dadosServidor"
      :servico="objetoServicos['Posto de Coleta de Exames']"
      @colher-payload="prepararPayloadServicos"
      @switch="switchHandler"
    ></posto-coleta-exames-componente>

    <otica-componente
      v-if="objetoServicos['Ótica'].ativo"
      :dadosServidor="this.dadosServidor"
      :servico="objetoServicos['Ótica']"
      @colher-payload="prepararPayloadServicos"
      @switch="switchHandler"
    ></otica-componente>

    <farmacia-componente
      v-if="objetoServicos['Farmácia'].ativo"
      :dadosServidor="this.dadosServidor"
      :servico="objetoServicos['Farmácia']"
      @colher-payload="prepararPayloadServicos"
      @switch="switchHandler"
    ></farmacia-componente>

    <saude-ocupacional-componente
      v-if="objetoServicos['Saúde Ocupacional'].ativo"
      :dadosServidor="this.dadosServidor"
      :servico="objetoServicos['Saúde Ocupacional']"
      @colher-payload="prepararPayloadServicos"
      @switch="switchHandler"
    ></saude-ocupacional-componente>

    <remocao-externa-componente
      v-if="objetoServicos['Remoção externa/independente'].ativo"
      :dadosServidor="this.dadosServidor"
      :servico="objetoServicos['Remoção externa/independente']"
      @colher-payload="prepararPayloadServicos"
      @switch="switchHandler"
    ></remocao-externa-componente>

    <outros-servicos-componente
      v-if="objetoServicos['Outros'].ativo"
      :dadosServidor="this.dadosServidor"
      :servico="objetoServicos['Outros']"
      @colher-payload="prepararPayloadServicos"
      @switch="switchHandler"
    ></outros-servicos-componente>
  </unicom-layout-cartao>
</template>

<script>
import ServicosMixin from "./ServicosMixin";

import PostoColetaExamesComponente from "./components/PostoColetaExamesComponente.vue";
import OticaComponente from "./components/OticaComponente.vue";
import FarmaciaComponente from "./components/FarmaciaComponente.vue";
import SaudeOcupacionalComponente from "./components/SaudeOcupacionalComponente.vue";
import RemocaoExternaComponente from "./components/RemocaoExternaComponente.vue";
import OutrosServicosComponente from "./components/OutrosServicosComponente.vue";

export default {
  mixins: [ServicosMixin],
  components: {
    PostoColetaExamesComponente,
    OticaComponente,
    FarmaciaComponente,
    SaudeOcupacionalComponente,
    RemocaoExternaComponente,
    OutrosServicosComponente
  },
  data() {
    return {};
  },
  methods: {
    prepararPayloadServicos(payloadDoComponente) {
      if (!payloadDoComponente) return;

      this.objetoServicos[payloadDoComponente.tipoServico].payload = {
        ...payloadDoComponente
      };

      if (payloadDoComponente.clickSwitch) {
        this.objetoServicos[payloadDoComponente.tipoServico].preenchido = true;
      }

      this.preparaDadosServicos();
    },
    switchHandler(payload) {
      this.objetoServicos[payload.tipoServico].preenchido = payload.clickSwitch;

      if (!payload.clickSwitch) {
        this.payloadServicos = this.payloadServicos.filter(
          servico => servico.tipoServico.tipoServico !== payload.tipoServico
        );
        this.payloadEspecialidades = this.payloadEspecialidades.filter(
          espe => espe.tipoServico.tipoServico !== payload.tipoServico
        );
        this.payloadAbrancencias = this.payloadAbrancencias.filter(
          abran => abran.tipoServico.tipoServico !== payload.tipoServico
        );
      }

      this.preparaDadosServicos();

      this.$emit("payload-atualizado", {
        servicos: [...this.payloadServicos],
        especialidades: [...this.payloadEspecialidades],
        abrangencias: this.payloadAbrancencias
      });
    }
  }
};
</script>

<style scoped>
.linha-embaixo {
  padding-bottom: 24px;
  border-bottom: 1px solid #ebebeb;
  margin-bottom: 24px;
}
</style>
